import { useParams } from "react-router-dom";

import { useAuth } from "../auth/AuthContext";
import { useSelectedGroups } from "../auth/hooks/useSelectedGroups";
import CoachingArtifactViewer from "./components/CoachingArtifactViewer";

const CoachingArtifactDetail = () => {
  const { id } = useParams<{ id: string }>();
  const { tenantId } = useAuth();
  const { permittedEmails } = useSelectedGroups();

  return <CoachingArtifactViewer artifactId={id} tenantId={tenantId} permittedEmails={permittedEmails} />;
};

export default CoachingArtifactDetail;
